export default __webpack_public_path__ + "static/media/telemedicine-call.7c6e0696.svg";